// features/client/client.dependencies.js

import apiUser from "../../api";

export const loadClientDependencies = async () => {
  const [
    companiesRes,
    countriesRes,
    tradesRes,
    businessTypesRes,
    designationsRes,
    adminsRes,
    userRolesRes
  ] = await Promise.allSettled([
    apiUser.getCompanies(),
    apiUser.getCountries(),
    apiUser.getTrades(),
    apiUser.getBusinessTypes(),
    apiUser.getDesignations(),
    apiUser.getAllClients({ role: "ADMIN" }),
    apiUser.getAllUserRoles()
  ]);

  const extract = (res) =>
    res.status === "fulfilled"
      ? res.value?.data?.data || []
      : [];

  const admins = extract(adminsRes).map(admin => ({
    ...admin,
    full_name: `${admin.first_name || ""} ${admin.last_name || ""}`.trim()
  }));

  return {
    companies: extract(companiesRes),
    countries: extract(countriesRes),
    trades: extract(tradesRes),
    businessTypes: extract(businessTypesRes).filter((type) => type.is_activated),
    designations: extract(designationsRes),
    admins,
    userRoles: extract(userRolesRes).map(role => ({
      ...role,
      role: role.role
    }))
  };
};